import { arrayOf, oneOfType, node } from 'prop-types';

import { extend } from '@thd-nucleus/data-sources';
import { AddToList } from '@thd-olt-component-react/add-to-list';
import { Price } from '@thd-olt-component-react/price';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';

export const DataModelWrapper = ({ children }) => {
  return children;
};

DataModelWrapper.propTypes = {
  children: oneOfType([
    arrayOf(node),
    node
  ]).isRequired
};

DataModelWrapper.displayName = 'DataModelWrapper';

DataModelWrapper.dataModel = extend({}, AddToList, Price, KeyProductFeatures);